import IconCommon, {
  IconAction,
  type IconProps as IconPropsCommon,
  IconWithProgress,
  type IconWithProgressProps
} from "@common/controls/Icon/component";
import classNames from "classnames";
import React from "react";

import "./style.less";

export { IconAction, IconWithProgress, type IconPropsCommon, type IconWithProgressProps };
export type IconProps = Omit<IconPropsCommon, "icon"> & {
  iconClassName: string;
};

const Icon = React.forwardRef(({ iconClassName, ...props }: IconProps, ref: React.RefObject<any>) => (
  <IconCommon {...props} ref={ref} icon={iconClassName} className={classNames("wsc_icon", props.className)} />
));

export default Icon;
